import clienteAxios from "../../../config/axios";

export const objectDefault = {
  idRegistro: 4,
  nombre_surtidor: "",
  lado: "A", //A O B
  user: "",
  fecReg: "",
  estacion1: {
    numero_pistola: 10,
    codigo_producto: "0101",
    nombre_producto: "EXTRA",
  },
  estacion2: {
    numero_pistola: 11,
    codigo_producto: "0185",
    nombre_producto: "SUPER",
  },
  estacion3: {
    numero_pistola: 12,
    codigo_producto: "0121",
    nombre_producto: "SUPER",
  },
};

export const columns = [
  // {
  //   id: "codigoCombustible",
  //   label: "Código Combustible",
  //   minWidth: 25,
  //   tipo: "string",
  //   propiedad: "codigoCombustible",
  // },
  {
    id: "fechaHora",
    label: "Fecha y Hora",
    minWidth: 25,
    tipo: "fecha-hora",
    propiedad: "fechaHora",
  },
  {
    id: "nombreCombustible",
    label: "Combustible",
    minWidth: 25,
    tipo: "string",
    propiedad: "nombreCombustible",
  },
  {
    id: "lado",
    label: "Lado",
    minWidth: 25,
    tipo: "string",
    propiedad: "lado",
  },
  {
    id: "pistola",
    label: "Manguera",
    minWidth: 25,
    tipo: "multipleSelectDataDefault",
    propiedad: "pistola",
    variante: "multipleSelectDataDefault",
    propiedadesMostrar: 2,
    campoData1: "numero_pistola",
    campoData2: "nombre_producto",

    getData: async () => {
      const resusuariosData = await clienteAxios.get(`/surtidores/todo`);
      console.log({ resusuariosData });

      const resultado = extraerEstaciones(resusuariosData.data);
      console.log(resultado);
      // Salida esperada:
      // [
      //   {
      //     numero_pistola: "1",
      //     codigo_producto: "0121",
      //     nombre_producto: "DIESEL PREMIUN"
      //   }
      // ]
      // setusuariosData(setitemsPersonas(resusuariosData.data));
      return { data: { data: resultado } };
    },
  },
  {
    id: "numeroTanque",
    label: "Tanque",
    minWidth: 25,
    tipo: "string",
    propiedad: "numeroTanque",
    variante: "select",
    options: [
      { value: 1, label: "SUPER" },
      { value: 2, label: "EXTRA" },
      { value: 3, label: "DIESEL" },
    ],
  },
  {
    id: "precioUnitario",
    label: "PVP",
    minWidth: 25,
    tipo: "",
    propiedad: "precioUnitario",
    ocultar: true,
  },
  {
    id: "valorTotal",
    label: "Total",
    minWidth: 25,
    tipo: "",
    propiedad: "valorTotal",
    ocultar: true,
  },
  {
    id: "volTotal",
    label: "Galones",
    minWidth: 25,
    tipo: "",
    propiedad: "volTotal",
    ocultar: true,
  },
  // {
  //   id: "tiempo",
  //   label: "Tiempo",
  //   minWidth: 25,
  //   tipo: "",
  //   propiedad: "tiempo",
  // ocultar: true,
  // },

  {
    id: "totInicio",
    label: "LEC. INI",
    minWidth: 25,
    tipo: "",
    propiedad: "totInicio",
    ocultar: true,
  },
  {
    id: "totFinal",
    label: "LEC. FIN",
    minWidth: 25,
    tipo: "",
    propiedad: "totFinal",
    ocultar: true,
  },
  // {
  //   id: "cedulaCliente",
  //   label: "Cliente",
  //   minWidth: 25,
  //   tipo: "string",
  //   propiedad: "cedulaCliente",
  //   variante: "autocompleteDataDefault",
  //   propiedadesMostrar: 2,
  //   campoData1: "perDocNumero",
  //   campoData2: "perNombre",

  //   getData: async () => {
  //     const resusuariosData = await clienteAxios.get(
  //       `proveedores/listar/por/perfil?perfil=USUARIO`
  //     );
  //     console.log({ resusuariosData });

  //     // setusuariosData(setitemsPersonas(resusuariosData.data));
  //     return { data: resusuariosData };
  //   },
  // },
  {
    id: "cedulaCliente",
    label: "Cliente",
    minWidth: 25,
    tipo: "string",
    propiedad: "cedulaCliente",
    variante: "autocompleteDataDefault",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",

    getData: async () => {
      const resusuariosData = await clienteAxios.get(
        `proveedores/listar/por/perfil?perfil=CLIENTE`
      );
      console.log({ resusuariosData });

      // setusuariosData(setitemsPersonas(resusuariosData.data));
      return { data: resusuariosData };
    },
  },
  {
    id: "usuario",
    label: "Usuario",
    minWidth: 25,
    tipo: "multipleSelectDataDefault",
    propiedad: "usuario",
    variante: "multipleSelectDataDefault",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",

    getData: async () => {
      const resusuariosData = await clienteAxios.get(
        `proveedores/listar/por/perfil?perfil=USUARIO`
      );
      console.log({ resusuariosData });

      // setusuariosData(setitemsPersonas(resusuariosData.data));
      return { data: resusuariosData };
    },
  },
];
function extraerEstaciones(arr) {
  return arr
    .flatMap((obj) => {
      // Recorre las posibles estaciones
      return [obj.estacion1, obj.estacion2, obj.estacion3]
        .filter((est) => est && Object.keys(est).length > 0) // Solo las que no están vacías
        .map((est) => ({
          numero_pistola: est.numero_pistola,
          nombre_producto: est.nombre_producto,
        }));
    })
    .sort((a, b) => Number(a.numero_pistola) - Number(b.numero_pistola)); // Ordena por numero_pistola
}
export const columnasHijo = [
  {
    id: "manguera",
    align: "left",
    minWidth: 150,
    tipo: "string",
    label: "manguera",
  },
  {
    id: "producto",
    align: "left",
    minWidth: 150,
    tipo: "string",
    label: "producto",
  },
];
